// US-C11: a API avalia cada chamada clinica/* numa única clínica (header
// X-Clinic-Id). A sessão fica de fora porque lista todas as clínicas da pessoa.
// O agendamento (POST admin/appointments) e a agenda do médico mexida pela
// clínica (admin/slots) também levam o header: a API só aceita unidade da
// clínica ativa.
export const CLINIC_HEADER = "X-Clinic-Id";
const SCOPED_PREFIXES = ["clinica/", "admin/appointments", "admin/slots"];

export function withClinicHeader(config, rootState) {
  const url = config.url || "";
  const clinicId = rootState.clinica && rootState.clinica.activeClinicId;
  const headers = config.headers || {};
  if (
    !clinicId ||
    !SCOPED_PREFIXES.some(prefix => url.startsWith(prefix)) ||
    url === "clinica/session" ||
    headers[CLINIC_HEADER]
  ) {
    return config;
  }
  config.headers = { ...headers, [CLINIC_HEADER]: clinicId };
  return config;
}
